import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentItemPreview } from './PaymentItemPreview';
import { PaymentItemBodySwitch } from './PaymentItemBodySwitch';
import { PAYMENT_METHOD_TYPES, TEXTS, STYLES } from '../consts/consts';

const {
  PAGES: {
    PAYMENTS: { PAYMENTS_LIST },
  },
} = STYLES;

interface IProps {
  paymentData: any;
  mutateExpandId: (id: string) => void;
  activeExpandId: string;
  handleSetSelectedPayment: (type: string, selected: boolean) => void;
  triggerReFetchOptionsList: () => void;
  isLastItem?: boolean;
  allowActive?: boolean;
}

const RECOMMENDED_PAYMENTS_TYPES = [PAYMENT_METHOD_TYPES.STRIPE_CARD, PAYMENT_METHOD_TYPES.STRIPE_BANK];

export const PaymentItem = ({
  paymentData,
  mutateExpandId,
  activeExpandId,
  handleSetSelectedPayment,
  triggerReFetchOptionsList,
  isLastItem,
  allowActive,
}: IProps) => {
  const { t } = useTranslation();
  const getTitleByType = () => {
    if (paymentData.type === PAYMENT_METHOD_TYPES.STRIPE_CARD) {
      return t(TEXTS.STEP_PAYMENTS.PAYMENT_METHOD_TITLE_STRIPE_CARD);
    }
    if (paymentData.type === PAYMENT_METHOD_TYPES.STRIPE_BANK) {
      return t(TEXTS.STEP_PAYMENTS.PAYMENT_METHOD_TITLE_STRIPE_BANK);
    }
    return `${t(TEXTS.STEP_PAYMENTS.CONNECT)} ${paymentData.optionName}`;
  };

  const isExpand = useMemo(() => activeExpandId === paymentData.type, [activeExpandId]);

  const previewData = useMemo(
    () => ({
      title: getTitleByType(),
      subTitle: paymentData.subtitle,
      logoName: paymentData.logoUrl,
      isRecommended: RECOMMENDED_PAYMENTS_TYPES.includes(paymentData.type),
      activated: paymentData.activated || false,
      selected: paymentData.selected || false,
      type: paymentData.type,
      accountStatus: paymentData.accountStatus,
    }),
    [paymentData],
  );
  return (
    <div
      className={`${isLastItem ? 'mb-[22px]' : ''} ${isExpand ? PAYMENTS_LIST.PAYMENT_ITEM_CONTAINER_EXPAND : ''} ${PAYMENTS_LIST.PAYMENT_ITEM_CONTAINER}`}
    >
      <PaymentItemPreview
        handleSetSelectedPayment={handleSetSelectedPayment}
        previewData={previewData}
        handleToggleExpand={() => mutateExpandId(paymentData.type)}
        isExpand={isExpand}
        allowActive={allowActive}
      />
      {isExpand && (
        <PaymentItemBodySwitch
          triggerReFetchOptionsList={triggerReFetchOptionsList}
          handleToggleExpand={() => mutateExpandId(paymentData.type)}
          method={paymentData}
        />
      )}
    </div>
  );
};
